"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var pusher_js_1 = __importDefault(require("pusher-js"));
var Types_1 = require("@CommonFrontendBackend/Pusher/Types");
module.exports = function (pusherAppKey, apiBaseUrl, $http) {
    var pusher = new pusher_js_1.default(pusherAppKey, {
        authEndpoint: "".concat(apiBaseUrl, "/pusher/auth"),
        authTransport: "jsonp",
        encrypted: true,
    });
    pusher.connection.bind("connected", function () {
        return ($http.defaults.headers.common[Types_1.PUSHER_SOCKET_ID] = pusher.connection.socket_id);
    });
    return pusher;
};
